
const resultsContainer = document.querySelector('.js-store-locator-results');

function loadLazyStoreHtml(el) {
    return new Promise((resolve) => {
        if (typeof $ === 'undefined') {
            console.error('jQuery is required for storeLocatorLazyload.js');
            return resolve(null);
        }
        var $el = $(el);
        var $container = $('.js-store-locator-results');
        var url = $el.attr('data-url');
        var spinner = $.spinner ? $container.spinner() : { start: function(){}, stop: function(){} };
        spinner.start();
        $.ajax({
            url: url,
            type: 'GET',
            success: function (html) {
                var $newContent = $(html);
                var storeIndexMatch = url && url.match(/storeIndex=(\d+)/);
                var storeIndex = storeIndexMatch ? storeIndexMatch[1] : null;
                if (storeIndex) {
                    $newContent.find('.store-locator__map-marker > span').text(storeIndex);
                }
                resolve($newContent);
            },
            error: function () {
                resolve(null);
            },
            complete: function () {
                spinner.stop();
            }
        });
    });
}

let scrollTimeout;
resultsContainer.addEventListener('scroll', function() {
    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(function() {
        if (Math.ceil(resultsContainer.scrollTop) + resultsContainer.clientHeight >= resultsContainer.scrollHeight) {
            const lazyStores = Array.from(document.querySelectorAll('.js-lazy-store')).slice(0, 5);
            lazyStores.forEach((el) => {
                loadLazyStoreHtml(el).then(($newContent) => {
                    if ($newContent) {
                        $(el).replaceWith($newContent);
                    }
                });
            });
        }
    }, 100);
});

module.exports = {
    loadLazyStoreHtml: loadLazyStoreHtml
}
